import {useState, useEffect, useContext} from "react"
import { UserContext } from '../Context/UserContext';

export default function useUserGamePolling(dispatch) {
    const {fetchUserGameDailyThreeYearStats, fetchUserGameDailyPitcherThreeYearStats} = useContext(UserContext);
    const [mostRecentGame, setMostRecentGame] = useState(null)
    const [mostRecentTeamTrends, setMostRecentTeamTrends] = useState(null)
    // const [mostRecentHitterStats, setMostRecentHitterStats] = useState(null)
    // const [mostRecentPitcherStats, setMostRecentPitcherStats] = useState(null)

    useEffect(() => {
        if (!mostRecentGame || mostRecentGame.calculation_status === "done") return;

        const interval = setInterval(async () => {
            try {
                const res = await fetch(`/user_games/${mostRecentGame.id}`);
                if (!res.ok) {
                    clearInterval(interval)
                    throw new Error(res.status);
                }

                const data = await res.json();
                setMostRecentGame(prev => {
                    if (!prev) return data;
                    if (prev.id === data.id && prev.calculation_status === data.calculation_status) {
                        return prev; // avoid setting identical logical state
                    }
                    return data;
                });

                if (data.calculation_status === "done" || data.calculation_status === "failed") {
                    clearInterval(interval);
                }
            } catch (err) {
                console.error("Polling error:", err);
            }
        }, 4000);

        return () => clearInterval(interval);
    }, [mostRecentGame?.id, mostRecentGame?.calculation_status]);

    useEffect(() => {
        if (!mostRecentGame || mostRecentGame.calculation_status !== "done") return;

        let mounted = true

        async function fetchUserGameTeamTrends() {
            //console.log('fetching trends for user game', mostRecentGame.id)
            try {
                const res = await fetch(`/user_game_team_trends/user_game/${mostRecentGame.id}`)
                if (!res.ok) throw new Error(res.status)
                
                const data = await res.json()
                if (!mounted) return

                //console.log('trends fetched', data)
                setMostRecentTeamTrends(data)

                dispatch({type: "setUserGameTeamTrends", payload: data})
            } catch (err) {
                console.error("Failed to fetch user game team trends: ", err)
            }
        }

        fetchUserGameTeamTrends()
        return () => {mounted = false}
    }, [mostRecentGame?.id, mostRecentGame?.calculation_status, dispatch])

    useEffect(() => {
        if (!mostRecentGame || mostRecentGame.calculation_status !== "done") return;

        fetchUserGameDailyThreeYearStats()
        fetchUserGameDailyPitcherThreeYearStats()
    }, [mostRecentGame?.id, mostRecentGame?.calculation_status])

    return {mostRecentGame, mostRecentTeamTrends, setMostRecentGame, setMostRecentTeamTrends}
}